export const fetchSnapshotNode = async (snapshotUrl?: string) => {
  if (!snapshotUrl) {
    return undefined;
  }
  const response = await fetch(snapshotUrl);
  const responseText = await response.text();

  try {
    return JSON.parse(responseText);
  } catch {
    return undefined;
  }
};
